// extracted by mini-css-extract-plugin
export var productImage = "_oq-1";
export var viewLink = "_oq-2";
export var wishlistItem = "_oq-0";